import { render } from "./BTWallCells.vue?vue&type=template&id=46371d88&scoped=true"
import script from "./BTWallCells.vue?vue&type=script&lang=js"
export * from "./BTWallCells.vue?vue&type=script&lang=js"

import "./BTWallCells.vue?vue&type=style&index=0&id=46371d88&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46371d88"]])

export default __exports__